import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'reset-css'
import 'normalize.css'
import './App.scss'
import App from './App'
import { DataContextProvider } from './Context/DataContext'
import { UIContextProvider } from './Context/UIContext'

const root = document.getElementById('root');
createRoot(root).render(
    <StrictMode>
        <DataContextProvider>
            <UIContextProvider>
                <App />
            </UIContextProvider>
        </DataContextProvider>
    </StrictMode>
)